import { PaymentSummary } from './utils/transactionTypes';
import { processSalesAndPayments, processReturns } from './utils/summaryCalculator';

export const useSummaryCalculations = () => {
  const calculateSummaries = (data: any): PaymentSummary[] => {
    if (!data) return [];

    const summariesMap = new Map<string, PaymentSummary>();
    let creditSummary: PaymentSummary = {
      method: "Crédit",
      amount: 0,
      transactions: []
    };

    processSalesAndPayments(data, summariesMap, creditSummary);
    processReturns(data, summariesMap);

    return [...Array.from(summariesMap.values()), creditSummary];
  };

  return { calculateSummaries };
};